<template>
  <div class="continent-letter">
    <el-descriptions size="medium">
      <el-descriptions-item label="保函状态">
        <!-- 未申请 -->
        <div v-if="businessNo !== letterInfo.businessNo">
          <div class="flex">
            <status-tag type="danger" label="未开立" size="small">-</status-tag>
            <el-button
              style="padding: 0 24px"
              type="text"
              @click="applyOnlineLetter"
            >
              在线保函申请
            </el-button>
            <span class="text-warning">保费低至400元</span>
          </div>
          <div class="letter-tip m-t-4">线上保函申请由大地保险提供</div>
        </div>
        <!-- 申请中 -->
        <div v-else-if="inApproval">
          <div class="flex col-top">
            <status-tag
              :config="onlineLetterApprovalStatusDict.APPLYING"
              size="small"
            />
            <el-button
              style="padding: 4px 24px"
              type="text"
              @click="cancelApply"
            >
              撤回申请
            </el-button>
          </div>
          <div class="letter-tip">未支付成功，请在撤回申请后重新申请保函</div>
        </div>
        <!-- 申请退回保函中 -->
        <div v-else-if="inApplyReturn">
          <div class="flex col-top">
            <status-tag
              :config="onlineLetterOrderStatusDict.SURRENDERING"
              size="small"
            />
            <el-button
              style="padding: 4px 24px"
              type="text"
              @click="cancelApplyReturn"
            >
              撤回申请
            </el-button>
          </div>
        </div>
        <!-- 开立成功 -->
        <div v-else-if="applySuccess">
          <div class="flex col-top">
            <status-tag
              :config="onlineLetterApprovalStatusDict.SUCCESS"
              size="small"
            />
            <span
              v-if="showApplyForReturn"
              class="text-primary clickable m-l-24"
              @click="applyForReturn"
            >
              申请退回保函
            </span>
          </div>
          <div v-if="returnRecords.length">
            <span>退款失败，</span>
            <el-button type="text" @click="openReturnRecordsDialog">
              点击查看详情
            </el-button>
          </div>
        </div>
        <!-- 开立失败 -->
        <div v-else>
          <status-tag
            :config="onlineLetterApprovalStatusDict.FAILED"
            size="small"
          />
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="保函有效期要求">
        <span>{{ gfLetterDays || '-' }} 天</span>
      </el-descriptions-item>
      <el-descriptions-item
        label=""
        label-class-name="descitem-label-class-name"
      >
        <div class="text-right" style="width: 100%;">
          <el-button type="text" class="p-t-0 p-b-0" @click="handleViewGfInfo">
            了解更多保函信息
          </el-button>
        </div>
      </el-descriptions-item>
      <template v-if="letterInfo.applyTime">
        <el-descriptions-item label="申请时间">
          <span>{{ letterInfo.applyTime }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付金额（元）">
          <div>
            <div>
              <span>{{ letterInfo.amount | moneyFilter }}</span>
              <!-- 申请发票失败 -->
              <!-- 申请发票成功 -->
              <template v-if="invoiceApplySuccess">
                <span
                  v-if="applyGeneralInvoice"
                  class="text-primary clickable m-l-16"
                  @click="downloadInvoice"
                >
                  申请成功，点击下载电子发票
                </span>
                <span v-else class="text-primary m-l-16">
                  申请成功，专票已邮寄
                </span>
              </template>
              <!-- 发票申请中 -->
              <span v-else-if="invoiceApplying" class="text-primary m-l-16">
                已申请发票
              </span>
              <!-- 未申请发票 -->
              <span
                v-else
                class="text-primary clickable m-l-16"
                @click="applyInvoice"
              >
                申请发票
              </span>
            </div>
            <money-in-cn :money="letterInfo.amount" />
          </div>
        </el-descriptions-item>
      </template>
      <el-descriptions-item v-if="letterOrder.refundTime" label="退保时间">
        <span>{{ letterOrder.refundTime }}</span>
      </el-descriptions-item>
      <template v-else-if="applySuccess">
        <el-descriptions-item label="开立时间">
          <span>{{ letterOrder.letterCreateTime }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="保函文件">
          <div>
            <div class="text-primary clickable" @click="openLetterFile">
              点击下载保函文件
            </div>
            <div class="letter-tip">线上保函申请由大地保险提供</div>
          </div>
        </el-descriptions-item>
      </template>
    </el-descriptions>

    <el-dialog
      :visible.sync="returnRecordsDialogVisible"
      title="退款失败详情"
      class="dialog"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-for="(item, index) in returnRecords" :key="index">
        <span>{{ item.refundTime }}</span>
        <span>{{ item.status }}</span>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="returnRecordsDialogVisible = false">
          确定
        </el-button>
      </div>
    </el-dialog>

    <apply-invoice
      ref="applyInvoice"
      :company-id="companyId"
      :on-confirm="onConfirmApplyInvoice"
    />
  </div>
</template>

<script>
import StatusTag from '@/components/common/StatusTag.vue'
import MoneyInCn from '@/components/common/MoneyInCn.vue'
import ApplyInvoice from '@/components/guarantee/ApplyInvoice.vue'
import {
  applyForReturnOnlineLetterApi,
  applyOnlineLetterApi,
  applyOnlineLetterInvoiceApi,
  cancelApplyForReturnOnlineLetterApi,
  cancelApplyOnlineLetterApi,
  getOnlineLetterApplicationNewestApi,
  getOnlineLetterReturnRecordsApi
} from '@/api/supplier/guaranteee'
import {
  onlineLetterApprovalStatusDict,
  onlineLetterInvoiceStatusDict,
  onlineLetterOrderStatusDict
} from '@/dictionary/guarantee'
import { strToThousands } from '@/utils/utils'
import { mapState } from 'vuex'
import { isAfter } from 'date-fns'
import DateUtils from '@/utils/date'
import { bidInviteBidStatusDict } from '@/dictionary/project/bid'
import { invoiceTypeDict } from '@/dictionary/financial'

/**
 * 大地保函
 */
export default {
  name: 'ContinentLetter',

  components: { StatusTag, MoneyInCn, ApplyInvoice },

  filters: {
    moneyFilter(value) {
      return strToThousands(value)
    }
  },

  props: {
    orderId: {
      type: [String, Number],
      required: true
    },

    tradeId: {
      type: [String, Number],
      required: true
    },

    // 变更公告id
    changeNoticeId: {
      type: [String, Number],
      default: ''
    },

    // 流标公告id
    closeNoticeId: {
      type: [String, Number],
      default: ''
    },

    // 允许申请撤回的时间节点
    canWithdrawTimeNode: {
      type: String,
      default: ''
    },

    // 项目状态
    orderStatus: {
      type: [String, Number],
      default: ''
    },

    // 保函单号
    businessNo: {
      type: String,
      default: ''
    },

    // 保函有效期要求
    gfLetterDays: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      onlineLetterApprovalStatusDict,
      onlineLetterOrderStatusDict,
      onlineLetterInvoiceStatusDict,

      letterInfo: {},

      returnRecords: [],
      returnRecordsDialogVisible: false
    }
  },

  computed: {
    ...mapState('systemTime', ['systemMillisecond']),
    ...mapState('company', ['companyId']),

    // 申请中
    inApproval() {
      return (
        this.letterInfo.approvalStatus ===
          onlineLetterApprovalStatusDict.APPLYING.value ||
        this.letterInfo.approvalStatus ===
          onlineLetterApprovalStatusDict.APPROVAL.value
      )
    },

    // 开立成功
    applySuccess() {
      return (
        this.letterInfo.approvalStatus ===
        onlineLetterApprovalStatusDict.SUCCESS.value
      )
    },

    // 申请退回中
    inApplyReturn() {
      return (
        this.letterOrder.orderStatus ===
        onlineLetterOrderStatusDict.SURRENDERING.value
      )
    },

    letterOrder() {
      return this.letterInfo.orderInfo || {}
    },

    letterInvoice() {
      return this.letterOrder.invoice || {}
    },

    // 开标时间后
    afterOpen() {
      return isAfter(
        new Date(this.systemMillisecond),
        new Date(DateUtils.safeDate(this.canWithdrawTimeNode))
      )
    },

    // 项目已流标
    projectFlowed() {
      const { CLOSED, RESTART } = bidInviteBidStatusDict
      const flowList = [CLOSED, RESTART].map(item => item.value)
      return flowList.includes(this.orderStatus)
    },

    /**
     * 是否显示申请退回按钮
     */
    showApplyForReturn() {
      // 仅在开标时间后且未流标时隐藏
      return !this.afterOpen || this.projectFlowed
    },

    // 申请发票成功
    invoiceApplySuccess() {
      return (
        this.letterInvoice.status ===
        onlineLetterInvoiceStatusDict.SUCCESS.value
      )
    },

    // 申请普票
    applyGeneralInvoice() {
      return this.letterInvoice.invoiceType === 0
    },

    // 申请发票中
    invoiceApplying() {
      return (
        this.letterInvoice.status ===
        onlineLetterInvoiceStatusDict.APPLYING.value
      )
    }
  },

  watch: {
    businessNo: {
      handler(val) {
        if (val) this.getOnlineLetter()
      },
      immediate: true
    }
  },

  created() {
    this.$store.dispatch('systemTime/getSystemTime')
  },

  methods: {
    /**
     * 申请保函
     */
    applyOnlineLetter() {
      if (this.afterOpen) {
        this.$message.warning('开标时间已截止，无法申请')
        return
      }
      if (this.projectFlowed) {
        this.$message.warning('项目已流标，操作失败')
        return
      }
      this.$systemConfirm(
        '该服务由由大地保险提供',
        '在线保函申请',
        '前往'
      ).then(bool => {
        if (!bool) return

        applyOnlineLetterApi(this.orderId, this.tradeId)
          .then(res => {
            const _data = res.data || {}
            window.open(_data.applyUrl, '_blank')
            this.$emit('reload')
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 获取保函信息
     */
    getOnlineLetter() {
      getOnlineLetterApplicationNewestApi(this.businessNo)
        .then(res => {
          if (!res.data?.isGiveUp) {
            this.letterInfo = res.data || {}
            this.$emit('getStatus', this.letterInfo.approvalStatus)
          } else {
            this.letterInfo = {}
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 撤回申请
     */
    cancelApply() {
      this.$systemConfirm('是否撤回申请').then(bool => {
        if (!bool) return

        cancelApplyOnlineLetterApi(this.orderId, this.tradeId)
          .then(res => {
            this.$message.success('已撤回申请')
            this.getOnlineLetter()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 下载保函文件
     */
    openLetterFile() {
      window.open(this.letterOrder.letterUrl, '_blank')
    },

    /**
     * 申请退回保函
     */
    applyForReturn() {
      if (this.projectFlowed) {
        this.$systemConfirm(
          h => (
            <div>
              <div>已超出保函有效期，申请失败</div>
              <div>如有疑问，请联系“王广英 18720065992”</div>
            </div>
          ),
          '申请退回保函'
        )
        return
      }

      this.$alert(
        '申请退回保函需线下提交相关材料，请联系0791-83902562 王广英',
        '系统提示',
        {
          confirmButtonText: '确定',
          callback: () => {
            applyForReturnOnlineLetterApi(this.orderId, this.tradeId)
              .then(res => {
                this.$message.success('已提交申请')
                this.getOnlineLetter()
              })
              .catch(err => {
                if (err?.message) this.$message.error(err.message)
              })
          }
        }
      )
    },

    /**
     * 取消退回保函申请
     */
    cancelApplyReturn() {
      this.$systemConfirm('是否撤回申请').then(bool => {
        if (!bool) return

        cancelApplyForReturnOnlineLetterApi(this.orderId, this.tradeId)
          .then(res => {
            this.$message.success('已撤回申请')
            this.getOnlineLetter()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 获取退保记录
     */
    getOnlineLetterReturnRecords() {
      getOnlineLetterReturnRecordsApi(this.businessNo)
        .then(res => {
          this.returnRecords = res.data || []
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 打开申请退保失败记录
     */
    openReturnRecordsDialog() {
      this.returnRecordsDialogVisible = true
    },

    /**
     * 申请开标
     */
    applyInvoice() {
      this.$refs.applyInvoice.open()
    },

    onConfirmApplyInvoice(invoiceInfo) {
      return new Promise(resolve => {
        const postData = {
          invoiceAddressId: invoiceInfo.id,
          businessNo: this.businessNo
        }
        applyOnlineLetterInvoiceApi(postData)
          .then(res => {
            this.$message.success('已提交申请')
            this.getOnlineLetter()
            resolve()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    downloadInvoice() {
      window.open(this.letterInvoice.invoiceUrl, '_blank')
    },

    /**
     * 了解更多保函信息
     */
    handleViewGfInfo() {
      const isProduct = process.env.VUE_APP_NODE_ENV === 'production'
      const isTest = process.env.VUE_APP_NODE_ENV === 'test'

      const url = isProduct
        ? '/article/449/detail'
        : isTest
          ? '/article/209/detail'
          : '/article/124/detail'
      window.open(`${process.env.VUE_APP_PORTAL_URL}${url}`, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.letter-tip {
  font-size: 12px;
  color: $third-text-color;
}

::v-deep .el-descriptions-item__label.has-colon {
  &.descitem-label-class-name::after {
    display: none;
  }
}
</style>
